import { InviteStatusEnum, PermissionTypeEnums } from '@/types'
import type { BadgeVariants } from '@/ui'

export const INVITE_STATUS_VARIANTS: Record<InviteStatusEnum, BadgeVariants['variant']> = {
  [InviteStatusEnum.CREATED]: 'orange',
  [InviteStatusEnum.SENT]: 'orange',
  [InviteStatusEnum.ACCEPTED]: 'green',
  [InviteStatusEnum.REJECTED]: 'red',
  [InviteStatusEnum.EXPIRED]: 'yellow',
  [InviteStatusEnum.CANCELLED]: 'secondary',
}

export const INVITE_STATUS_TITLES: Record<InviteStatusEnum, string> = {
  [InviteStatusEnum.CREATED]: 'Pending',
  [InviteStatusEnum.SENT]: 'Pending',
  [InviteStatusEnum.ACCEPTED]: 'Accepted',
  [InviteStatusEnum.REJECTED]: 'Rejected',
  [InviteStatusEnum.EXPIRED]: 'Expired',
  [InviteStatusEnum.CANCELLED]: 'Cancelled',
}

export const PERMISSION_TYPE_TITLES: Record<PermissionTypeEnums, string> = {
  [PermissionTypeEnums.VIEW_APPOINTMENTS]: 'View Appointments',
  [PermissionTypeEnums.CREATE_APPOINTMENTS]: 'Create Appointments',
  [PermissionTypeEnums.EDIT_APPOINTMENTS]: 'Edit Appointments',
  [PermissionTypeEnums.DELETE_APPOINTMENTS]: 'Delete Appointments',
  [PermissionTypeEnums.VIEW_PATIENTS]: 'View Patients',
  [PermissionTypeEnums.CREATE_PATIENTS]: 'Create Patients',
  [PermissionTypeEnums.EDIT_PATIENTS]: 'Edit Patients',
  [PermissionTypeEnums.DELETE_PATIENTS]: 'Delete Patients',
  [PermissionTypeEnums.VIEW_MESSAGES]: 'View Messages',
  [PermissionTypeEnums.CREATE_MESSAGES]: 'Create Messages',
  [PermissionTypeEnums.VIEW_LEADS]: 'View Leads',
  [PermissionTypeEnums.EDIT_LEADS]: 'Edit Leads',
  [PermissionTypeEnums.DELETE_LEADS]: 'Delete Leads',
  [PermissionTypeEnums.VIEW_FEEDS]: 'View Feeds',
  [PermissionTypeEnums.CREATE_FEEDS]: 'Create Feeds',
  [PermissionTypeEnums.EDIT_FEEDS]: 'Edit Feeds',
  [PermissionTypeEnums.VIEW_EHR_ROLES]: 'View EHR Roles',
  [PermissionTypeEnums.ASSIGN_EHR_ROLES]: 'Assign EHR Roles',
  [PermissionTypeEnums.INVITE_USERS]: 'Invite Users',
  [PermissionTypeEnums.EDIT_USERS]: 'Edit Users',
  [PermissionTypeEnums.REMOVE_USERS]: 'Remove Users',
  [PermissionTypeEnums.VIEW_CLINICS]: 'View Clinics',
  [PermissionTypeEnums.EDIT_CLINICS]: 'Edit Clinics',
}
